import React from 'react';
import "./QuienesSomos.css";

import useFadeInOnScroll from "../../useFadeInOnScroll";

function QuienesSomos() {
  useFadeInOnScroll();

  return (
    <div className="div-QuienesSomos fade-in">
      <div className='QuienesSomos-title fade-in'>
        <div className='QuienesSomosTitle-open' >
          <h2 className='QuienesSomosTitle-opentext'>¿</h2>
        </div>
        <div className='QuienesSomostitle-text' >
        <div className="QuienesSomostext-Quienes">Quiénes</div>
        <div className="QuienesSomostext-Somos">somos</div>
        </div>
        <div className='QuienesSomosTitle-close' >
          <h2 className='QuienesSomosTitle-closetext'>?</h2>
        </div>


        {/* <h2 className="headline-QuienesSomos">¿Quiénes somos?</h2> */}
      </div>
      {/* <h2 className="headline-QuienesSomos fade-in">¿Quiénes somos?</h2> */}

      <p className="body-QuienesSomos fade-in">
        En Cogote celebramos la tradición de la parrilla al carbón, ofreciendo cortes 
        de carne de la más alta calidad con un sabor auténtico que honra nuestras 
        raíces tabasqueñas. Nuestra misión es brindar a cada comensal una experiencia única, donde la hospitalidad y la pasión por la cocina se encuentran en cada plato.
      </p>

      <p className="body-QuienesSomos fade-in">
        Ser reconocidos como la churrascaría de referencia en la región y más allá, destacando por nuestro compromiso con la excelencia culinaria, la innovación gastronómica y la calidez de nuestro servicio. Queremos ser un punto de encuentro donde la cultura, la familia y el buen comer se fusionen.
      </p>

      <div className="quienes-somos-image fade-in"></div>

      <h5 className="heading-QuienesSomos fade-in">Valores</h5>

      <ul className="body-QuienesSomos fade-in">
        <li className='li-QuienesSomos'><strong>Tradición:</strong> Honramos las recetas y técnicas que nos conectan con nuestras raíces.</li>
        <li className='li-QuienesSomos'><strong>Calidad:</strong> Seleccionamos los mejores ingredientes para garantizar un sabor excepcional.</li>
        <li className='li-QuienesSomos'><strong>Hospitalidad:</strong> Tratamos a cada cliente como parte de nuestra familia.</li>
        <li className='li-QuienesSomos'><strong>Innovación:</strong> Buscamos constantemente nuevas formas de sorprender y deleitar.</li>
        <li className='li-QuienesSomos'><strong>Compromiso local:</strong> Promovemos productos y proveedores de la región, apoyando el desarrollo de nuestra comunidad.</li>
      </ul>

      <a href="https://www.google.com/maps/place/Cogote+Churrascaria/..." target="blank">
        <img src="../Assets/mapas-image.png" alt="maps" className="mapas-image fade-in"/>
      </a>

      <h5 className="heading-QuienesSomos fade-in">Nuestros Horarios</h5>

      <p className="body-QuienesSomos fade-in">Lunes a Jueves – 1pm a 10pm</p>
      <p className="body-QuienesSomos fade-in">Viernes y Sábado – 1pm a 11pm</p>
      <p className="body-QuienesSomos fade-in">Domingo – 1pm a 7pm</p>
    </div>
  );
}

export default QuienesSomos